import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('[AC Nautitech] VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set in environment. Cannot initialize Supabase client without credentials.');
}

// TICKET-1100: supabase-js passes no AbortSignal, so a request that never settles
// (iOS WebKit networking-process crash, 2026-10-05) hangs its caller forever — and a
// hung /auth token refresh also stalls auth-js's queue, so EVERY later .from() waits
// behind it. Bound PostgREST + auth calls; storage uploads keep their own pacing.
export const SUPABASE_REQUEST_TIMEOUT_MS = 20000;

export function boundedFetch(input, init = {}) {
  const url = typeof input === 'string' ? input : input?.url || '';
  if (init.signal || !/\/(rest|auth)\/v1\//.test(url)) return fetch(input, init);
  return fetch(input, { ...init, signal: AbortSignal.timeout(SUPABASE_REQUEST_TIMEOUT_MS) });
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  global: { fetch: boundedFetch },
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'acn-auth',
    lock: async (name, acquireTimeout, fn) => await fn(),
  },
  realtime: {
    params: { eventsPerSecond: 10 },
  },
});

export default supabase;
